import {FC, useContext, useState} from 'react';
import {Link} from 'react-router-dom';
import {
    Collapse,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarBrand,
    NavbarToggler,
} from 'reactstrap';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEllipsisV} from '@fortawesome/pro-solid-svg-icons/faEllipsisV';
import routes, {getRoute} from '../../route-map';
import {useSelector} from "react-redux";
import Selectors from "~/state/selectors.ts";

export const AppHeader : FC = () => {
    const cnum = useSelector(Selectors.getCustomerNumber);
    const ctx = useSelector(Selectors.getAppContext);

    const [isOpen, setOpen] = useState<boolean>(true);
    const [dropdownIsOpen, setDropdownOpen] = useState<boolean>(false);

    const toggleNav = () => {
        setOpen(!isOpen);
    };

    const toggleDropdown = () => {
       setDropdownOpen(!dropdownIsOpen);
    };

        const brandOpts = {
            tag: Link,
            to: '/',
        };

        return (
            <Navbar dark color="tn-purple" expand="md" fixed="top">
                <NavbarBrand {...brandOpts}>
                    <h1 className="sr-only">TN ERP Service</h1>
                    TN ERP Service
                </NavbarBrand>
                <NavbarToggler onClick={toggleNav} />
                <Collapse navbar isOpen={isOpen}>
                    <Nav navbar className="ml-auto">
                        <Dropdown nav inNavbar isOpen={dropdownIsOpen} toggle={toggleDropdown} className="ml-3">
                            <DropdownToggle nav>
                                <FontAwesomeIcon className="text-white" icon={faEllipsisV} />
                                <span className="sr-only">Toggle nav dropdown</span>
                            </DropdownToggle>
                            <DropdownMenu end>
                                <DropdownItem tag={Link} to={getRoute(routes.app.logout, {cnum, ctx})}>
                                    Logout
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </Nav>
                </Collapse>
            </Navbar>
        );
    }

export default AppHeader;
